export enum InvoiceStatus {
  Canceled = 5,
  Paid = 1,
  Unpaid = 0,
}
